import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import GenericDialog from './GenericDialog';
import { routePage } from '../../store/route-page';

class NotGeolocatedAddressesDialog extends Component {
  render() {
    const { t, open, onClose } = this.props;
    const notGeolocatedAddresses = routePage.notGeolocatedStops.map(stop => ({ uuid: stop.addressUuid, type: stop.addressType }));
    const title = t('dialogs.notGeolocatedAddresses.title');
    const json = JSON.stringify(notGeolocatedAddresses, null, 2);
    const buttons = [{ text: t('buttons.ok'), onClick: onClose }];
    return (
      <GenericDialog open={open} onClose={onClose} title={title} buttons={buttons}>
        <pre>{json}</pre>
      </GenericDialog>
    );
  }
}

NotGeolocatedAddressesDialog.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withNamespaces()(NotGeolocatedAddressesDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/NotGeolocatedddressesDialog.js